import { render, staticRenderFns } from "./PopupTrialLesson.vue?vue&type=template&id=be66c5e8&scoped=true&"
import script from "./PopupTrialLesson.vue?vue&type=script&lang=js&"
export * from "./PopupTrialLesson.vue?vue&type=script&lang=js&"
import style0 from "./PopupTrialLesson.vue?vue&type=style&index=0&id=be66c5e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be66c5e8",
  null
  
)

export default component.exports